/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListCompletedEvaluationData } from './genericApiResponseListCompletedEvaluationData';
import type { GenericApiResponseListCompletedEvaluationMessage } from './genericApiResponseListCompletedEvaluationMessage';
import type { GenericApiResponseListCompletedEvaluationPagination } from './genericApiResponseListCompletedEvaluationPagination';
import type { GenericApiResponseListCompletedEvaluationError } from './genericApiResponseListCompletedEvaluationError';

export interface GenericApiResponseListCompletedEvaluation {
  data?: GenericApiResponseListCompletedEvaluationData;
  message?: GenericApiResponseListCompletedEvaluationMessage;
  pagination?: GenericApiResponseListCompletedEvaluationPagination;
  error?: GenericApiResponseListCompletedEvaluationError;
  statusCode?: number;
}
